import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CaseState } from '@debbie/common/dist/cases/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { AggregationType } from '@debbie/common/dist/insights/aggregations.js';
import { h, c } from '@debbie/cortex/dist/index.js';
import * as reportsAPI from '@debbie/cortex/dist/api/insights.js';
import { selectProcedures } from '@debbie/cortex/dist/procedures/selectors.js';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors.js';
import THEME from '../../theme.js';
import Button from '../Button.js';
import { Row, Col } from '../Grid/index.js';
import EmailLarge from '../Icons/EmailLarge.js';
import Select from '../Select.js';
import Well from '../Well.js';
import Aggregation from './Aggregation.js';
import BulkActions from './BulkActions.js';
import CaseFilterBadges from './CaseFilterBadges.js';
import filterGroups from './groups/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { selectMe } from '@debbie/cortex/dist/me/selectors.js';
const AdvancedFilter = (props) => {
    const _caseFilter = useSelector((s) => s.caseFilter);
    const caseFilter = { ..._caseFilter, ...props.caseFilter };
    const procedures = useSelector(selectProcedures);
    const tenant = useSelector(selectTenant);
    const workflows = useSelector(selectWorkflows);
    const isImportsNotLoaded = useSelector((s) => h.isNotLoaded(s.allImports));
    const exclusiveContent = useSelector(selectExclusiveContent);
    const me = useSelector(selectMe);
    const lang = useSelector((s) => s.lang);
    const currentLang = useSelector((s) => s.currentLang);
    const [loading, setLoading] = useState(false);
    const [exportStarted, setExportStarted] = useState(false);
    const [aggregation, setAggregation] = useState(AggregationType.CountAll);
    useEffect(() => {
        isImportsNotLoaded && c.imports.getAll();
    }, []);
    useEffect(() => {
        if (!procedures) {
            c.procedures.get();
        }
        if (!workflows) {
            c.workflows.getAll();
        }
    }, []);
    useEffect(() => {
        setExportStarted(false);
    }, [caseFilter]);
    const hasExclusiveContent = !!(me && exclusiveContent?.includes(me.id));
    return (React.createElement("div", null,
        React.createElement(Row, null,
            React.createElement(Col, { width: "8" }, (tenant?.type
                ? filterGroups[tenant.type]
                : filterGroups[TenantType.Agency]).map((GroupComponent) => {
                return (React.createElement(GroupComponent, { onChange: props.onChange, caseFilter: caseFilter }));
            })),
            React.createElement(Col, { width: "4", style: { position: 'sticky', top: `${THEME.GRID_SPACING}px` } },
                React.createElement(Well, null,
                    React.createElement(Select, { value: aggregation || '', onChange: (e) => setAggregation(e.target.value || null) },
                        React.createElement("option", { disabled: true, value: "" },
                            "- ",
                            lang.aggregations.aggregate,
                            " -"),
                        Object.values(AggregationType)
                            .filter((type) => {
                            // Hide some for tenant.type=AccountsReceivable
                            if (tenant?.type === TenantType.AccountsReceivable &&
                                !hasExclusiveContent &&
                                [
                                    AggregationType.ByBillingAppendixSetup,
                                    AggregationType.ByBillingModel,
                                    AggregationType.ByCreditor,
                                ].includes(type)) {
                                return false;
                            }
                            return true;
                        })
                            .map((type) => (React.createElement("option", { key: type, value: type }, lang.aggregationTypes[type])))),
                    aggregation && (React.createElement(Aggregation, { caseFilter: caseFilter, type: aggregation })),
                    React.createElement(CaseFilterBadges, { caseFilter: caseFilter })),
                exportStarted ? (React.createElement("div", null,
                    React.createElement(EmailLarge, { style: {
                            width: '8em',
                            height: '8em',
                            margin: '0 auto',
                            display: 'block',
                        } }),
                    React.createElement("h3", { style: { textAlign: 'center' } }, lang.insights.reportOrdered),
                    React.createElement("p", { style: { textAlign: 'center' } }, lang.insights.reportOrderedText))) : (React.createElement(Button, { loading: loading, onClick: async () => {
                        setLoading(true);
                        try {
                            await reportsAPI.requestCaseOverviewReport([], currentLang, CaseState.ALL, undefined, undefined, undefined, undefined, caseFilter);
                            setExportStarted(true);
                        }
                        catch (error) {
                            console.error(error);
                            alert('Error');
                        }
                        setLoading(false);
                    }, style: { margin: '20px 0' }, block: true }, lang.caseFilter.orderCaseOverview)),
                React.createElement(BulkActions, { caseFilter: caseFilter })))));
};
export default AdvancedFilter;
//# sourceMappingURL=AdvancedFilter.js.map